export const HORIZONTAL_BOOKMARK= "polygon(0% 0%, 75% 0%, 100% 50%, 75% 100%, 0% 100%)"